<template>
  <button
    :class="[
      'btn',
      {
        primary: variant === 'primary',
        success: variant === 'success',
        secondary: variant === 'secondary',
        outline: variant === 'secondary-outline',
        delete: variant === 'delete',
        info: variant === 'info',
        danger: variant === 'danger',
        'danger-outline': variant === 'dangerOutline',
        secondary2: variant === 'secondary2',
        warning: variant === 'warning',
        'dark-blue': variant === 'darkBlue',
      },
      { 'sidebar-btn': small },
    ]"
    :id="id"
    :type="type"
    @click.stop="click"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    :style="cus_style"
    :disabled="disabled || loading"
  >
    <div class="d-flex justify-content-center align-items-center">
      <b-spinner
        small
        v-if="loading"
        style="margin-inline-end: 0.5rem"
      ></b-spinner>
      <slot></slot>
    </div>
  </button>
</template>

<script>
export default {
  emits: ["click", "mouseenter", "mouseleave"],
  props: ["id", "type", "variant", "cus_style", "loading", "disabled", "small"],
  methods: {
    click() {
      this.$emit("click");
    },
    mouseenter() {
      this.$emit("mouseenter");
    },
    mouseleave() {
      this.$emit("mouseleave");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  font-size: 14px;
  font-weight: 700;
  border-radius: 6px;
  padding: 10px 20px;
  width: 100%;
  cursor: pointer;
  white-space: nowrap;
}
.btn:focus {
  box-shadow: none;
}
.primary {
  background-color: var(--color-23);
  color: var(--color-01);
  border: 1px solid var(--color-23);
  &:hover {
    background-color: var(--color-04);
    color: var(--color-61);
    border: 1px solid var(--color-113);
  }
  &:disabled {
    opacity: 0.3;
  }
}
.success {
  background: var(--color-01);
  border: 1px solid var(--color-145);
  color: var(--color-144);
  &:hover {
    background-color: var(--color-145);
    color: var(--color-01);
    border: 1px solid var(--color-145);
  }
  &:disabled {
    opacity: 0.3;
  }
}
.secondary {
  background-color: var(--color-01);
  color: var(--color-09);
  border: 1px solid var(--color-114);
  &:hover {
    background-color: var(--color-11);
    color: var(--color-61);
    border: 1px solid var(--color-113);
  }
  &:disabled {
    opacity: 0.3;
  }
}
.dark-blue {
  background-color: var(--color-01);
  color: var(--color-146);
  border: 1px solid var(--color-147);
  &:hover {
    background-color: var(--color-147);
    color: var(--color-01);
    border: 1px solid var(--color-147);
  }
  &:disabled {
    opacity: 0.3;
  }
}
.outline {
  padding: 5px 10px;
  background-color: transparent;
  color: var(--color-09);
  border: 1px solid var(--color-114);
  &:hover {
    background-color: var(--color-11);
    color: var(--color-61);
    border: 1px solid var(--color-113);
  }
  &:disabled {
    opacity: 0.3;
  }
}

.delete {
  background-color: var(--color-01);
  color: var(--color-27);
  border: 1px solid var(--color-27);
  &:hover {
    background-color: var(--color-27);
    color: var(--color-01);
    border: 1px solid var(--color-27);
  }
  &:disabled {
    opacity: 0.3;
  }
}

.info {
  background-color: var(--color-122);
  color: var(--color-01);
  border: 1px solid var(--color-122);
  &:hover {
    background-color: var(--color-122);
    color: var(--color-01);
    border: 1px solid var(--color-122);
  }
  &:disabled {
    opacity: 0.3;
  }
}

.danger {
  background-color: var(--color-27);
  color: var(--color-01);
  border: 1px solid var(--color-27);
  &:hover {
    background-color: var(--color-07);
    color: var(--color-01);
    border: 1px solid var(--color-27);
  }
  &:disabled {
    opacity: 0.3;
  }
}

.danger-outline {
  background-color: transparent;
  color: var(--color-27);
  border: 1px solid var(--color-27);
  &:hover {
    background-color: var(--color-07);
    color: var(--color-01);
    border: 1px solid var(--color-27);
  }
  &:disabled {
    opacity: 0.3;
  }
}

.secondary2 {
  background-color: var(--color-81);
  color: var(--color-01);
  border: 1px solid var(--color-81);
  &:hover {
    background-color: var(--color-81);
    color: var(--color-01);
    border: 1px solid var(--color-81);
  }
  &:disabled {
    opacity: 0.3;
  }
}

.warning {
  background: var(--color-01);
  border: 1px solid var(--color-40);
  color: var(--color-29);
  &:hover {
    background-color: var(--color-29);
    color: var(--color-01);
    border: 1px solid var(--color-29);
  }
  &:disabled {
    opacity: 0.3;
  }
}

.sidebar-btn {
  padding: 5px 10px;
}
</style>
